import { DataSourceSetupComposite, enumATSModes } from "./DataSourceSetupComposite";
import { DATA_SOURCES_TEST_PREFIX } from "../Utils";
import { Checkbox, TextArea } from "@theorgchartdev/storybook";
import { appcstr } from "@coreapp/utils/appcstr";

export const ICIMSSetupComposite = ({ config, onChange, index, importType, chartConfig }) => {
  const { doCustomiCIMSBaseProfile, customiCIMSBaseProfile } = config;

  return (
    <DataSourceSetupComposite
      config={config}
      onChange={onChange}
      index={index}
      chartConfig={chartConfig}
      showInputControls
      showConfiguration={importType !== "import"}
      showLoadHeaders={false}
      importType={importType}
      ATSType={enumATSModes.pureATS}
    >
      <Checkbox
        id={"toggle-sandbox"}
        data-testid={`${DATA_SOURCES_TEST_PREFIX}-icims-sandbox-checkbox`}
        label={appcstr("Custom Base Profile")}
        size={"medium"}
        checked={doCustomiCIMSBaseProfile}
        onChange={() =>
          onChange({ ...config, doCustomiCIMSBaseProfile: !doCustomiCIMSBaseProfile })
        }
      />
      {doCustomiCIMSBaseProfile && (
        <TextArea
          dataTestId={`${DATA_SOURCES_TEST_PREFIX}-icims-custom-base-profile-textarea`}
          inputOnly
          size="medium"
          value={customiCIMSBaseProfile}
          placeholder={""}
          onChange={event => onChange({ ...config, customiCIMSBaseProfile: event.target.value })}
        />
      )}
    </DataSourceSetupComposite>
  );
};
